import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  props: {
    colorClass: String,
    background: String,
    foreground: String,
    logo: Object,
    items: Array,
    hideOnInitial: Boolean,
  },
})

export default class CubeHeaderX extends Vue {
  @Watch('$route', { immediate: true, deep: true })
  onRouteChanged(value: any, oldValue: any) {
    const refNavBar = document.getElementById('navBarItems');
    if (refNavBar === null) {
      return;
    }
    if (refNavBar.getAttribute('aria-expanded') !== 'true') {
      return;
    }
    const refNavBarButton = document.getElementById('navBarButton');
    if (refNavBarButton === null) {
      return;
    }
    refNavBarButton.click();
  }

  public mounted() {
    const windowRef = window as any;
    if (windowRef.$(window).width() >= 768) {
      windowRef.$('.sticky-header .primary-nav').css({
        top: '50px',
        transform: 'translateY(0px)',
      });
      windowRef.$(window).on('scroll', () => {
        if (windowRef.$(window).scrollTop() >= windowRef.$(window).height()) {
          windowRef.$('.sticky-header .primary-nav').css({
            top: '50%',
            transform: 'translateY(-50%)',
          });
        } else {
          windowRef.$('.sticky-header .primary-nav').css({
            top: '50px',
            transform: 'translateY(0px)',
          });
        }
      });
    }
    windowRef.$(window).on('scroll', () => {
      if (windowRef.$(window).scrollTop() >= 1) {
        windowRef.$('.site-header.fixed').addClass('is-sticky');
        windowRef.$('.site-header.fixed').find('.nav-list-item.white').removeClass('white');
      } else {
        windowRef.$('.site-header.fixed').removeClass('is-sticky');
        windowRef.$('.site-header.fixed').find('.nav-list-item:not(.dark)').addClass('white');
      }
    });
    if (windowRef.$(window).width() < 768) {
      windowRef.$('.site-header.fixed').find('.nav-list-item').removeClass('white');
      windowRef.$(window).on('scroll', () => {
        if (windowRef.$(window).scrollTop() >= 1) {
          windowRef.$('.site-header.fixed').find('.nav-list-item').removeClass('white');
        } else {
          windowRef.$('.site-header.fixed').find('.nav-list-item').removeClass('white');
        }
      });
    }

    windowRef.$('.nav-list').singlePageNav({
      offset: windowRef.$('.sticky-header').outerHeight(),
      currentClass: 'active',
      updateHash: false,
      easing: 'easeInOutExpo',
      speed: 900,
    });
    windowRef.$('.nav-list-item:not(.mp-nav)').singlePageNav({
      offset: windowRef.$('.site-header').outerHeight(),
      currentClass: 'active',
      updateHash: false,
      easing: 'easeInOutExpo',
      speed: 900,
    });
    windowRef.$('.site-header-sticky').sticky({
      topSpacing: 0,
    });
    if (windowRef.$(window).width() < 768) {
      windowRef.$('.sticky-header').sticky({
        topSpacing: 0,
      });
    }
  }

  private NavigateDirect(url: string): void {
    window.location.href = url;
  }
}
